"use client";
import React from "react";

interface Props {
  text: string;
}

const CategoryDescriptionToggle = ({ text }: Props) => {
  return (
    <div className="p-5 md:p-6 rounded-2xl bg-white border border-[#800000]/10">
      <p
        className="text-slate-600 text-sm leading-relaxed"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
        }}
      >
        {text}
      </p>
      <a
        href="#category-full-description"
        className="mt-2 inline-block text-[11px] font-black text-[#800000] uppercase tracking-widest hover:opacity-70 transition-opacity no-underline"
      >
        See More
      </a>
    </div>
  );
};

export default CategoryDescriptionToggle;
